<xng-breadcrumb separator="{{ seperator }}">
  <ng-container
    *xngBreadcrumbItem="let breadcrumb; let info = info; let first = first; let last = last"
  >
    <ng-container>{{ breadcrumb | translate }}</ng-container>
  </ng-container>
</xng-breadcrumb>
